// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","BoldHeading":"BoldHeading-67rzxbswxsgzjjt2zv4jwya6muzfzrk7hjtge7547cwu3z6vzebhyhp4x4yvb5g6usg48mgqctjkbkc9pp8hpuuseem6crv5d2m7g8","RodoPolicyContent":"RodoPolicyContent-4ubn1zcb3fjjqcej98db6rby4g2fn47ywu1ed6fgf2fhk7cu9ge3mhzxsdvxz7zpjsexrxscpkbfsqr333v2xt3y3s38eqktgq4x1yj","loading":"loading-43tjvyhq3hs6p2dqsjfxwhga6gczcu7r48dcwdbqhwp1jfyye5ytaw3k71e7hpbvx3zgthgd46g828wpfytvy71w1k26u7hn3q5p8wj","pulse":"pulse-4qvmmefw4n1bpt7p4hzrk2mk53jr8srmhdg62emb85ea77845zkwu74jfatc2bj8ywgnmnr4b7rzq4jj2uvbu9gbnrdcum6acr3ufa7"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ZszPolicy/ZszPolicy.module.scss
// module id = 1795
// module chunks = 0